export default {
  methods: {
    registerSuccessNotification: function(success_notification) {
      this.$store.dispatch("notifications/registerSuccessNotification", {
        title: success_notification.title, message: success_notification.message
      });
    },
  }
}